import { render, staticRenderFns } from "./page-payment-error.vue?vue&type=template&id=bb0a8c10"
import script from "./page-payment-error.js?vue&type=script&lang=js&external"
export * from "./page-payment-error.js?vue&type=script&lang=js&external"
import style0 from "./page-payment-error.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports